var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestHolidaysBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1304 525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#edeefc;}.cls-3{fill:#e4e5f8;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#0d37c9;}.cls-6{fill:#e9a4b3;}.cls-7{fill:#707070;}.cls-8{fill:#b5b5b5;}.cls-9{fill:#d998a9;}.cls-10{fill:#22d696;}.cls-11{fill:#00a7ff;}.cls-12{fill:#6e3d3d;}.cls-13{clip-path:url(#clip-path-2);}.cls-14{fill:#ab5654;}.cls-15{fill:#fff;}.cls-16{fill:#1a1818;}.cls-17{clip-path:url(#clip-path-3);}.cls-18{fill:url(#linear-gradient);}.cls-19{fill:url(#linear-gradient-2);}.cls-20{fill:url(#linear-gradient-3);}.cls-21{fill:url(#linear-gradient-4);}.cls-22{fill:#f9f9f9;}.cls-23{fill:#f7f8f8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1093.19,59.35a.47.47,0,0,1,.49.46v0a4.31,4.31,0,0,1-2.53,3.42c-2.74,1.37-6.45.8-8.25-1a5.39,5.39,0,0,1-1.11-2.61.41.41,0,0,1,.35-.48h.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108.08,59.35a.46.46,0,0,1,.48.46v0a4.31,4.31,0,0,1-2.53,3.42c-2.74,1.37-6.45.8-8.25-1a5.48,5.48,0,0,1-1.11-2.61.41.41,0,0,1,.35-.48h.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.65,383.84l-5.23-3L100.33,375c-.56-.33-1.12-.13-1.12.54v23.74c0,.51.4.73.89.45l10.32-6,5.23-3,5-2.9c.59-.34.54-.81,0-1.08S115.65,383.84,115.65,383.84Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -47.86,
    y1: 676.45,
    x2: -47.86,
    y2: 675.45,
    gradientTransform: "matrix(12.96, 0, 0, -25.7, 726, 17759.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2f8da6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#66b6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cc6af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -44.69,
    y1: 675.41,
    x2: -43.69,
    y2: 675.41,
    gradientTransform: "matrix(16.44, 0, 0, -12.94, 833.94, 9123.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab59d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -44.19,
    y1: 675.91,
    x2: -44.19,
    y2: 674.91,
    gradientTransform: "matrix(16.44, 0, 0, -12.94, 833.91, 9135.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4282d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ba2d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#83357b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e388d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -54.29,
    y1: 674.96,
    x2: -54.29,
    y2: 673.96,
    gradientTransform: "matrix(9.46, 0, 0, -6.9, 630.46, 5043.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f07165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#faa460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba5e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-2",
    x: 10.51,
    y: 92.1,
    width: 1280,
    height: 423,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    className: "cls-3",
    d: "M1069.39,46.92a1.55,1.55,0,0,1,0-.21c.28-1.63.61-3.25,1-4.84h0c-2-12.78,2.92-18.24,7.16-21h0c2.28-4.46,4.72-7.6,7-8.66,4.21-2,9.05-1.79,12.4-1.31a5.72,5.72,0,0,0-2.47-1.44c2.11-.13,6.6,2.33,6.6,2.33,30-8.75,31,34.43,29.52,44.32s8.65,14,23.12,23.12c13.13,8.28,20.21,17.2,24,24.27a22.83,22.83,0,0,1-1.13,6.4,4.75,4.75,0,0,0-1.42-.92c0,.09.39,1.06.86,2.44a23.33,23.33,0,0,1-19,14.46l-16.35,1.89-3.15.36L1113.11,131c-2.57-3.65-5.37-7.42-8.28-11.16a242.38,242.38,0,0,0-21.56-24.6c-2.22-2.16-4.33-4-6.27-5.58l-.21-.16a28.13,28.13,0,0,1-2.31-5.63,68.6,68.6,0,0,1-2.5-15.06A66.4,66.4,0,0,0,1073.39,84a26.19,26.19,0,0,0,1,3.34,18.08,18.08,0,0,1-2.3-3.14C1067,75.44,1067,60.77,1069.39,46.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    className: "cls-3",
    d: "M1068.1,95.33s-46.18,44.22-68.48,45.46-39.4,1.61-39.4,1.61v8.54s32.5,10.39,64.67,5.82c6.44-.91,50.93-25.15,50.93-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    className: "cls-3",
    d: "M1183.88,221.32c-.74,1.79-3.94,3.38-8.56,4.52-10.33,2.57-27.77,2.91-40.48-1.8-13.63-5-23.52-77.1-27.72-114-1.47-12.88-2.25-21.49-2.25-21.49s7.83-12.26,38.14-8.18,33.37,14.31,36.09,32.69S1186.26,215.53,1183.88,221.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    className: "cls-3",
    d: "M1175.33,225.84c-10.34,2.57-27.77,2.91-40.49-1.8-13.63-5-23.52-77.1-27.72-114,3.59-12.71,6.44-21.07,6.44-21.07s38-4.6,45.46,6.9C1165.64,106.11,1173.7,205.06,1175.33,225.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    className: "cls-3",
    d: "M1147.76,230.28c-10.43-23.38-15.41-30-15.59-37.34-.13-5.82,2.73-12.09,8.3-27.48a56.85,56.85,0,0,0,2.78-11.13c3.77-25.41.31-58.38-12.42-62.54-3.35-1.09-9.47-1.06-11-1.37-3-.79-8-11.5-7.94-28.77l-1.33.27-22.45,4.44s.51,7.07.53,13.73c0,5.54-.32,10.8-1.58,11.46l-2.57.24s-18.72,26-20.29,50.18,15,34.68-.13,83C1048.65,274.32,1153.51,243.2,1147.76,230.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    className: "cls-3",
    d: "M1088.12,66.36s.51,7.07.53,13.72c12.56-.35,19.2-11.81,21.92-18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    className: "cls-3",
    d: "M1083.92,72.66s29.73.49,29.75-18,3.87-30.92-15.11-32-22.67,6-24.18,12.14S1076.19,72.06,1083.92,72.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    className: "cls-3",
    d: "M1121.44,454.59a294.07,294.07,0,0,1-18.74,52.55l-9.8-.68a276.14,276.14,0,0,0,4.53-53.76c-.19-21.6-2.86-47.13-11.4-71.5-29.33-83.77-24.59-144.73-24.59-144.73l55.16,6.45,2.57.3c.23,25.33.88,59.72,1.45,86.61.51,24.19,1,42.3,1,42.3C1132.18,395,1128.32,427.21,1121.44,454.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    className: "cls-3",
    d: "M1153.08,449.84c-3.17,33.84-17.13,55.73-17.13,55.73l-4.68,3.4s-4.44-23.85-7.57-52.22c-3-27-7.09-55.5-11.72-64.2-18.39-34.54-23.93-164.92-23.93-164.92l55.92-2.78c5.62,9.46,8.08,25,8.66,42.6,1.47,44.5-9,102.52-10.56,110.91v0a3,3,0,0,0,.36,1.88C1153.56,402.28,1155.17,427.48,1153.08,449.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    className: "cls-3",
    d: "M1154.77,247.15a13.18,13.18,0,0,1-.35,4.47c-1.19,3.75-5.28,5.46-15.15,4.43-6-.62-8.74-10.74-9.93-19.37q-5.44,18.52-15.27,20.73c-9.58,2.13-57.88,8-61-15-3.48-25.25,6.93-70,7.5-94.1a119.45,119.45,0,0,1-1.75-22.34c.4-17.18,5.45-26.81,9.32-30.69,1.1-.84,2.2-1.37,6.6-2.12,2.26-.39,5.38-.83,9.8-1.42a15.05,15.05,0,0,1,1.77-.13c-.82,1.46-9.73,16-8.88,20.26.89,4.46,30.2,5.11,34.43.56,2.47-2.66,12.83-21.78,12.83-21.78s13.74,1.5,20.46,6.39l-.07.09A5.66,5.66,0,0,1,1146.8,99c2.69,5.12,4.39,25.35,5.5,49.34.36,7.65-1.84,38.38-1.6,46.44C1151.74,228.94,1154.44,240.62,1154.77,247.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    className: "cls-3",
    d: "M1108.35,515.36h-6.26c-2.1-.33-3.64-.93-5.79-1.21-3.27-.43-4.77.9-5.07,1.21l-.06.07h-26.58c-.67-1,0-3.17.6-4.8a3.76,3.76,0,0,1,2.49-2.27c2.82-.82,8.37-1.55,13.46-6.16,2.87-2.58,13.83-9.51,13.83-9.51h.06c.24,0,1.39.35,6.37,4.56,2.58,2.18,7-3.06,7-3.06a6,6,0,0,1,1.44,1.95,6.6,6.6,0,0,1,.57,4.08c-.4,2.4.89,6.84,1.9,9.86.62,1.82,1.15,3.12,1.15,3.12S1113.73,514.69,1108.35,515.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    className: "cls-3",
    d: "M1141.74,515.36h-6.26c-2.1-.33-3.64-.93-5.79-1.21-3.26-.43-4.77.9-5.07,1.21a.18.18,0,0,0,0,.07H1098c-.66-1,0-3.17.6-4.8a3.76,3.76,0,0,1,2.49-2.27c2.82-.82,8.38-1.55,13.47-6.16,2.86-2.58,13.82-9.51,13.82-9.51h.06c.24,0,1.38.35,6.37,4.56,2.58,2.17,7-3.07,7-3.07a6.14,6.14,0,0,1,1.44,2,6.67,6.67,0,0,1,.58,4.08c-.4,2.4.88,6.84,1.9,9.86.62,1.82,1.14,3.11,1.14,3.11S1147.12,514.69,1141.74,515.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    className: "cls-3",
    d: "M1145,97.17s48.64,49.77,46.79,66.8-42.29,57.43-42.29,57.43L1146,210.9s22.87-46.28,20.92-48.8-28.34-18.95-30.84-23.41S1145,97.17,1145,97.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    className: "cls-3",
    d: "M1146,210.9s-14.45-1.48-15.79,0-6.67,13-2.44,13.34,9.09-4.12,11-3.17,5.54,4.58,9.53,2.1c1.25-.78,2.25-3.16,4.16-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    className: "cls-3",
    d: "M1146,210.9s-5.62-1.71-7.18-3-2,2.35,1.26,3.46A7.5,7.5,0,0,0,1146,210.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    className: "cls-3",
    d: "M944.12,149.79h0a7.26,7.26,0,0,0,3,1.15,45.91,45.91,0,0,0,13.14,0V142.4a22.52,22.52,0,0,1-3.62-3.35,43.81,43.81,0,0,1-3.07-6.36c-2.89.25-.45,6.45-1.92,6.65-.73.1-3-.1-5.18.09h0c-2.15.19-4.15.76-4.27,2.41C942,144.4,941.46,147.87,944.12,149.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    className: "cls-3",
    d: "M944.12,149.79h0c5.65,1,9.78-4.88,9.73-7.25s-7.43-3.1-7.43-3.1h0c-2.15.18-4.15.76-4.27,2.41C942,144.39,941.46,147.87,944.12,149.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    className: "cls-3",
    d: "M1071.62,93.82s-4.57.45-12.87,8.06S1030.92,126,1030.92,126s4.84,21.1,29.61,22.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    className: "cls-3",
    d: "M1084.5,91.79l-.06.1c-1.32,2.09-21.94,35-23.91,56.46a118.61,118.61,0,0,1-1.75-22.34c2.65-8.1,9.08-26.08,15.92-32.81C1075.56,92.35,1084.5,91.79,1084.5,91.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    className: "cls-3",
    d: "M1144.21,96.48a77.14,77.14,0,0,1,13.52,11.67c7.52,7.95,19.93,24.54,19.93,24.54a38.54,38.54,0,0,1-32.94,24.08c-25.42,2.17-11.66-24.41-11.66-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    className: "cls-3",
    d: "M1139.61,88.17S1123,98.24,1121,137.57s29.74,57.24,29.74,57.24l.3-12.1s-26.55-23.48-19.06-54.81,18.75-38,18.75-38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    className: "cls-3",
    d: "M1093.19,59.35a.47.47,0,0,1,.49.46v0a4.31,4.31,0,0,1-2.53,3.42c-2.74,1.37-6.45.8-8.25-1a5.39,5.39,0,0,1-1.11-2.61.41.41,0,0,1,.35-.48h.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    className: "cls-3",
    d: "M1094.83,62.25a13.68,13.68,0,0,0-6.51-1.27,6,6,0,0,0-3.3,1c-1.32.94-1.58,2.45-.24,3.51a4.7,4.7,0,0,0,1.09.67,7.14,7.14,0,0,0,2.42.48,9.41,9.41,0,0,0,5.85-1.38,2,2,0,0,0,1-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    className: "cls-3",
    d: "M1091.59,58.41c.24.12.18.92,0,1.09a1.47,1.47,0,0,1-.73.29,23.38,23.38,0,0,1-6.63,0,2.21,2.21,0,0,1-.63-.13.92.92,0,0,1-.58-.78,2.35,2.35,0,0,1,.19-.78"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    className: "cls-3",
    d: "M1086.48,20.53s6.73,23.91,19.77,28.46,19.12,1.47,19.12,1.47a37.88,37.88,0,0,1-10.46-23.34S1094,10.05,1086.48,20.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    className: "cls-3",
    d: "M1088.48,22.59s-6.93,4.63-8.93,9.53S1076,47.32,1073,46.71c0,0-5.22-16.31,2.89-24.6C1084.45,13.32,1088.48,22.59,1088.48,22.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090-2",
    "data-name": "Path 2090-2",
    className: "cls-5",
    d: "M1084.27,46.92a1.55,1.55,0,0,1,0-.21c.29-1.63.61-3.25,1-4.84h0c-2-12.78,2.91-18.24,7.16-21h0c2.27-4.46,4.71-7.6,7-8.66,4.21-2,9-1.79,12.4-1.31a5.72,5.72,0,0,0-2.47-1.44c2.12-.13,6.6,2.33,6.6,2.33,30-8.75,31,34.43,29.52,44.32s8.65,14,23.12,23.12c13.14,8.28,20.21,17.2,24,24.27a22.83,22.83,0,0,1-1.13,6.4,4.63,4.63,0,0,0-1.42-.92c0,.09.39,1.06.87,2.44a23.36,23.36,0,0,1-19,14.46l-16.36,1.89-3.14.36L1128,131c-2.57-3.65-5.37-7.42-8.28-11.16a242.38,242.38,0,0,0-21.56-24.6,82.59,82.59,0,0,0-6.27-5.58l-.21-.16a28.13,28.13,0,0,1-2.31-5.63,68.6,68.6,0,0,1-2.5-15.06A67,67,0,0,0,1088.27,84a28,28,0,0,0,1,3.34,18.08,18.08,0,0,1-2.3-3.14C1081.9,75.44,1081.83,60.77,1084.27,46.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_111-2",
    "data-name": "Group 111-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093-2",
    "data-name": "Path 2093-2",
    className: "cls-6",
    d: "M1083,95.33s-46.18,44.22-68.48,45.46-39.4,1.61-39.4,1.61v8.54s32.5,10.39,64.68,5.82c6.43-.91,50.92-25.15,50.92-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095-2",
    "data-name": "Path 2095-2",
    className: "cls-7",
    d: "M1198.76,221.32c-.74,1.79-3.94,3.38-8.55,4.52-10.34,2.57-27.77,2.91-40.49-1.8-13.63-5-23.52-77.1-27.72-114-1.47-12.88-2.25-21.49-2.25-21.49s7.83-12.26,38.14-8.18S1191.26,94.65,1194,113,1201.14,215.53,1198.76,221.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096-2",
    "data-name": "Path 2096-2",
    className: "cls-8",
    d: "M1190.21,225.84c-10.34,2.57-27.77,2.91-40.49-1.8-13.63-5-23.52-77.1-27.72-114,3.59-12.71,6.44-21.07,6.44-21.07s38-4.6,45.46,6.9C1180.53,106.11,1188.58,205.06,1190.21,225.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098-2",
    "data-name": "Path 2098-2",
    className: "cls-6",
    d: "M1162.64,230.28c-10.42-23.38-15.41-30-15.58-37.34-.14-5.82,2.73-12.09,8.3-27.48a57.54,57.54,0,0,0,2.77-11.13c3.77-25.41.31-58.38-12.42-62.54-3.35-1.09-9.46-1.06-11-1.37-3-.79-8-11.5-7.94-28.77l-1.33.27L1103,66.36s.51,7.07.52,13.72c0,5.55-.32,10.8-1.57,11.47-1.62.14-2.57.24-2.57.24s-18.72,26-20.3,50.17,15,34.68-.12,83C1063.53,274.32,1168.4,243.2,1162.64,230.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099-2",
    "data-name": "Path 2099-2",
    className: "cls-9",
    d: "M1103,66.36s.51,7.07.53,13.72c12.56-.35,19.2-11.81,21.92-18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101-2",
    "data-name": "Path 2101-2",
    className: "cls-6",
    d: "M1098.81,72.66s29.72.49,29.74-18,3.87-30.92-15.11-32-22.67,6-24.18,12.14S1091.07,72.06,1098.81,72.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104-2",
    "data-name": "Path 2104-2",
    className: "cls-10",
    d: "M1136.32,454.59a294.07,294.07,0,0,1-18.74,52.55l-9.8-.68a276.92,276.92,0,0,0,4.53-53.76c-.19-21.6-2.86-47.13-11.4-71.5-29.33-83.77-24.59-144.73-24.59-144.73l55.15,6.45,2.57.3c.23,25.33.89,59.72,1.46,86.61.51,24.19,1,42.3,1,42.3C1147.06,395,1143.21,427.21,1136.32,454.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105-2",
    "data-name": "Path 2105-2",
    className: "cls-10",
    d: "M1168,449.84c-3.17,33.84-17.13,55.73-17.13,55.73l-4.68,3.4s-4.43-23.85-7.57-52.22c-3-27-7.09-55.5-11.72-64.2-18.39-34.54-23.93-164.92-23.93-164.92l55.92-2.78c5.63,9.46,8.08,25,8.66,42.6,1.47,44.5-9,102.52-10.55,110.91,0,0,0,0,0,0a2.94,2.94,0,0,0,.37,1.88C1168.44,402.28,1170.05,427.48,1168,449.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107-2",
    "data-name": "Path 2107-2",
    className: "cls-11",
    d: "M1169.65,247.15a13.18,13.18,0,0,1-.35,4.47c-1.19,3.75-5.27,5.46-15.15,4.43-6-.62-8.73-10.74-9.93-19.37q-5.45,18.52-15.27,20.73c-9.58,2.13-57.88,8-61-15-3.48-25.25,6.93-70,7.5-94.1a120.3,120.3,0,0,1-1.75-22.34c.4-17.18,5.45-26.81,9.33-30.69,1.1-.84,2.2-1.37,6.6-2.12,2.25-.39,5.37-.83,9.8-1.42a14.73,14.73,0,0,1,1.76-.13c-.82,1.46-9.73,16-8.88,20.26.89,4.46,30.2,5.11,34.43.56,2.47-2.66,12.83-21.78,12.83-21.78s13.74,1.5,20.46,6.39l-.07.09a5.69,5.69,0,0,1,1.77,1.85c2.68,5.12,4.38,25.35,5.5,49.34.35,7.65-1.85,38.38-1.6,46.44C1166.63,228.94,1169.32,240.62,1169.65,247.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109-2",
    "data-name": "Group 109-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108-2",
    "data-name": "Path 2108-2",
    className: "cls-5",
    d: "M1123.23,515.36H1117c-2.1-.33-3.64-.93-5.79-1.21-3.27-.43-4.77.9-5.07,1.21l-.06.07h-26.58c-.66-1,0-3.17.6-4.8a3.76,3.76,0,0,1,2.49-2.27c2.82-.82,8.38-1.55,13.47-6.16,2.86-2.58,13.82-9.51,13.82-9.51h.06c.24,0,1.39.35,6.37,4.56,2.58,2.18,7-3.06,7-3.06a6,6,0,0,1,1.44,1.95,6.53,6.53,0,0,1,.58,4.08c-.4,2.4.88,6.84,1.9,9.86.62,1.82,1.14,3.12,1.14,3.12S1128.61,514.69,1123.23,515.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110-2",
    "data-name": "Group 110-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109-2",
    "data-name": "Path 2109-2",
    className: "cls-5",
    d: "M1156.62,515.36h-6.25c-2.1-.33-3.65-.93-5.8-1.21-3.26-.43-4.76.9-5.06,1.21l-.06.07h-26.58c-.67-1,0-3.17.6-4.8a3.73,3.73,0,0,1,2.48-2.27c2.82-.82,8.38-1.55,13.47-6.16,2.86-2.58,13.82-9.51,13.82-9.51h.06c.24,0,1.39.35,6.38,4.56,2.57,2.17,7-3.07,7-3.07a6.46,6.46,0,0,1,1.44,2,6.6,6.6,0,0,1,.57,4.08c-.4,2.4.88,6.84,1.9,9.86.62,1.82,1.14,3.11,1.14,3.11S1162,514.69,1156.62,515.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111-2",
    "data-name": "Path 2111-2",
    className: "cls-6",
    d: "M1159.91,97.17s48.65,49.77,46.79,66.8-42.29,57.43-42.29,57.43l-3.56-10.5s22.87-46.28,20.91-48.8-28.33-18.95-30.84-23.41S1159.91,97.17,1159.91,97.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112-2",
    "data-name": "Path 2112-2",
    className: "cls-6",
    d: "M1160.85,210.9s-14.45-1.48-15.78,0-6.68,13-2.45,13.34,9.09-4.12,11.05-3.17,5.55,4.58,9.54,2.1c1.24-.78,2.24-3.16,4.15-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113-2",
    "data-name": "Path 2113-2",
    className: "cls-6",
    d: "M1160.85,210.9s-5.63-1.71-7.18-3-2,2.35,1.25,3.46A7.52,7.52,0,0,0,1160.85,210.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114-2",
    "data-name": "Path 2114-2",
    className: "cls-6",
    d: "M959,149.79h0a7.31,7.31,0,0,0,3,1.15,46,46,0,0,0,13.15,0V142.4a22.17,22.17,0,0,1-3.63-3.35,44.87,44.87,0,0,1-3.07-6.36c-2.89.25-.45,6.45-1.91,6.65-.73.1-3-.1-5.19.09h0c-2.15.19-4.15.76-4.27,2.41C956.85,144.4,956.34,147.87,959,149.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115-2",
    "data-name": "Path 2115-2",
    className: "cls-9",
    d: "M959,149.79h0c5.65,1,9.78-4.88,9.73-7.25s-7.43-3.1-7.43-3.1h0c-2.15.18-4.14.76-4.27,2.41C956.85,144.39,956.34,147.87,959,149.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116-2",
    "data-name": "Path 2116-2",
    className: "cls-11",
    d: "M1086.51,93.82s-4.58.45-12.88,8.06S1045.8,126,1045.8,126s4.84,21.1,29.61,22.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117-2",
    "data-name": "Path 2117-2",
    className: "cls-7",
    d: "M1099.38,91.79l-.06.1c-1.32,2.09-21.93,35-23.91,56.46a119.45,119.45,0,0,1-1.75-22.34c2.65-8.1,9.09-26.08,15.93-32.81C1090.44,92.35,1099.38,91.79,1099.38,91.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118-2",
    "data-name": "Path 2118-2",
    className: "cls-11",
    d: "M1159.09,96.48a76.78,76.78,0,0,1,13.52,11.67c7.53,7.95,19.94,24.54,19.94,24.54a38.56,38.56,0,0,1-33,24.08c-25.41,2.17-11.66-24.41-11.66-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119-2",
    "data-name": "Path 2119-2",
    className: "cls-7",
    d: "M1154.49,88.17s-16.61,10.07-18.65,49.4,29.74,57.24,29.74,57.24l.3-12.1s-26.55-23.48-19.06-54.81,18.76-38,18.76-38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_729-2",
    "data-name": "Group 729-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-2",
    "data-name": "Path 2183-2",
    className: "cls-12",
    d: "M1108.08,59.35a.46.46,0,0,1,.48.46v0a4.31,4.31,0,0,1-2.53,3.42c-2.74,1.37-6.45.8-8.25-1a5.48,5.48,0,0,1-1.11-2.61.41.41,0,0,1,.35-.48h.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_728-2",
    "data-name": "Group 728-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727-2",
    "data-name": "Group 727-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-2",
    "data-name": "Path 2184-2",
    className: "cls-14",
    d: "M1109.71,62.25A13.68,13.68,0,0,0,1103.2,61a6,6,0,0,0-3.3,1c-1.32.94-1.58,2.45-.24,3.51a4.7,4.7,0,0,0,1.09.67,7.14,7.14,0,0,0,2.42.48,9.41,9.41,0,0,0,5.85-1.38,2,2,0,0,0,1-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-2",
    "data-name": "Path 2185-2",
    className: "cls-15",
    d: "M1106.47,58.41c.24.12.18.92,0,1.09a1.47,1.47,0,0,1-.72.29,23.45,23.45,0,0,1-6.64,0,2.21,2.21,0,0,1-.63-.13.92.92,0,0,1-.58-.78,2.62,2.62,0,0,1,.19-.78"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091-2",
    "data-name": "Path 2091-2",
    className: "cls-5",
    d: "M1101.36,20.53s6.74,23.91,19.77,28.46,19.13,1.47,19.13,1.47a37.89,37.89,0,0,1-10.47-23.34S1108.84,10.05,1101.36,20.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092-2",
    "data-name": "Path 2092-2",
    className: "cls-5",
    d: "M1103.36,22.59s-6.93,4.63-8.93,9.53-3.59,15.2-6.58,14.59c0,0-5.22-16.31,2.89-24.6C1099.33,13.32,1103.36,22.59,1103.36,22.59Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestHolidaysBanner);
export default __webpack_public_path__ + "static/media/request-holidays-banner.b33f399eff174f8ba475a0ae24ad9446.svg";
export { ForwardRef as ReactComponent };